export interface ArticleSection {
  heading: string;
  paragraphs: string[];
}

export interface Article {
  id: string;
  title: string;
  excerpt: string;
  category: string;
  date: string;
  readTime: string;
  author: string;
  cover: string;
  coverAlt: string;
  tags: string[];
  featured: boolean;
  sections: ArticleSection[];
}

export const articles: Article[] = [
  {
    id: "midnight-vote-spike",
    title: "凌晨两点票数突然拉升：一场选美决赛的投票曲线疑云",
    excerpt:
      "决赛投票通道关闭前六小时，某位选手的票数以每分钟数百票的速度跳涨。我们整理了公开的分钟级票数快照，试图还原那条异常曲线的成因。",
    category: "打榜观察",
    date: "2026-08-28",
    readTime: "9 分钟",
    author: "瓜圈显微镜编辑部",
    cover:
      "https://readdy.ai/api/search-image?query=Elegant%20dark%20crimson%20stage%20with%20a%20large%20glowing%20line%20chart%20projected%20on%20the%20backdrop%2C%20warm%20gold%20spotlights%2C%20stylized%20editorial%20photography%2C%20dramatic%20haze%2C%20no%20visible%20faces%2C%20high%20contrast%2C%20moody%20premium%20magazine%20aesthetic&width=1200&height=800&seq=guaguan-vote-curve&orientation=landscape",
    coverAlt: "选美决赛舞台背景上投影的票数曲线图",
    tags: ["票数注水", "投票曲线", "数据观察"],
    featured: true,
    sections: [
      {
        heading: "一条不该存在的上升线",
        paragraphs: [
          "决赛夜的投票通道从晚上八点开放到次日凌晨。前五个小时里，各选手的票数增长曲线基本平行，只在粉丝集中投票的时间段出现小幅波动。真正的异常出现在凌晨两点十分前后。",
          "当时排名第四的选手，票数在二十分钟内增加了将近四万票，而同一时间段内其余选手的合计增量不足六千。这条陡峭的上升线，成为赛后讨论最多的截图。",
        ],
      },
      {
        heading: "正常拉票做不到这种斜率",
        paragraphs: [
          "我们按公开的票数快照做了简单换算：如果要把四万票在二十分钟内投出来，相当于每分钟两千票、每秒三十三次有效提交。即便后援会组织得再严密，也需要大量账号在同一个时间窗口内机械地重复动作。",
          "更值得注意的是账户结构。多位整理投票链接的网友提到，那一时段新增的投票账号中，有相当比例是当天注册、没有头像、没有历史互动的新号。",
        ],
      },
      {
        heading: "主办方与选手方的回应",
        paragraphs: [
          "赛后第二天，主办方发布了一份简短说明，称系统在高峰时段出现过「短时数据回填」，属于技术故障而非人为操作，并承诺对异常票段进行复核。",
          "涉事选手的后援会则表示，当晚确实组织过一轮「接力冲刺」，但强调所有投票都来自真实粉丝。截至发稿，主办方尚未公布复核结果，榜单页面也仍保留着原排名。",
        ],
      },
      {
        heading: "这条曲线到底说明什么",
        paragraphs: [
          "单看一条曲线，无法直接断定存在违规。它可能来自组织化刷票，也可能来自系统回填、缓存写入延迟，甚至是数据接口的显示问题。但它至少说明了一件事：当投票结果直接决定名次时，票数的可信度本身就需要被检验。",
          "我们的建议很朴素——把分钟级数据、账号注册时间分布、单 IP 提交频次这些维度公开出来，比任何一句「数据真实有效」都更有说服力。",
        ],
      },
    ],
  },
  {
    id: "fan-club-48-hours",
    title: "后援会「刷票小组」的48小时：粉丝内战是怎么打起来的",
    excerpt:
      "同一个选手的后援会，因为要不要继续集资打榜而分裂成两派。争吵从群里蔓延到超话，最后变成一场公开的对峙。",
    category: "粉丝生态",
    date: "2026-08-25",
    readTime: "8 分钟",
    author: "莫见微",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20amber%20lit%20backstage%20dressing%20room%20with%20scattered%20glitter%20and%20a%20crown%20resting%20on%20a%20velvet%20stool%2C%20stylized%20editorial%20photography%2C%20soft%20warm%20tones%2C%20shallow%20depth%20of%20field%2C%20no%20visible%20people%2C%20premium%20magazine%20aesthetic&width=1200&height=800&seq=guaguan-fan-club&orientation=landscape",
    coverAlt: "后台化妆间里的皇冠与散落亮片",
    tags: ["粉丝内战", "后援会", "集资"],
    featured: false,
    sections: [
      {
        heading: "两个群，两种立场",
        paragraphs: [
          "压力出现在投票通道开放后的第三个晚上。一边主张「必须把所有资源砸在打榜上，名次掉下去粉丝就白干了」，另一边则提出「连续三天集资，账目一直没公开，先把钱的去向说清楚」。",
          "起初只是语气分歧，很快变成了立场对立。负责对接后援会的粉丝说，当晚群里刷屏超过两千条，最后管理员直接开启了全员禁言。",
        ],
      },
      {
        heading: "刷票小组的日常",
        paragraphs: [
          "一位自称参与过打榜的粉丝描述了他们那两天的作息：早上八点领任务，用小号在三个平台分别投票，中午报进度，晚上再冲一轮，凌晨统计总量。整个流程被做成表格，分工明细到每个人负责多少个账号。",
          "这套组织方式本身并不违规，很多赛事的投票规则也默认粉丝可以集中拉票。问题在于规模一旦膨胀，账号从哪来、钱从哪里出，就很容易越过边界。",
        ],
      },
      {
        heading: "内战真正的代价",
        paragraphs: [
          "这场争执没有赢家。部分粉丝选择退群，留下的则继续用更激烈的方式互相指责，原本围绕选手的讨论，最终变成了关于「谁更配当粉丝」的审问。",
          "有选手在采访中间接提到过这种压力：名次的涨落变成了粉丝情绪的晴雨表，而当事人反而失去了表达的空间。",
        ],
      },
    ],
  },
  {
    id: "cost-of-one-vote",
    title: "一票到底值多少钱？打榜成本调查实录",
    excerpt:
      "从几分钱一个的批量账号，到明码标价的人工投票，投票背后的价格表比想象中更完整。我们整理了公开流传的几种收费方式。",
    category: "票数分析",
    date: "2026-08-21",
    readTime: "7 分钟",
    author: "瓜圈显微镜编辑部",
    cover:
      "https://readdy.ai/api/search-image?query=Close%20up%20of%20a%20vintage%20calculator%20and%20stacked%20paper%20tallies%20on%20a%20dark%20crimson%20velvet%20table%2C%20warm%20gold%20lighting%2C%20stylized%20editorial%20product%20photography%2C%20moody%20premium%20magazine%20aesthetic%2C%20no%20people&width=1200&height=800&seq=guaguan-cost-table&orientation=landscape",
    coverAlt: "深红色绒布桌面上的计算器与票数统计纸",
    tags: ["打榜成本", "集资", "价格调查"],
    featured: true,
    sections: [
      {
        heading: "价格区间的三个档位",
        paragraphs: [
          "在公开流传的报价里，投票服务大致分成三档。最便宜的是批量账号票，通常按千票计价，单价被压到极低；中档是「真人设备票」，由兼职用户使用真实设备完成；最高的一档则是保证票段位置、承诺时间点的定制投放。",
          "这三档之间的差异，本质上是「有多像真人在投票」。价格越高，账号的注册历史、设备指纹和操作节奏就越接近真实用户。",
        ],
      },
      {
        heading: "粉丝集资的钱花在哪",
        paragraphs: [
          "后援会的集资通常由几个部分组成：投票服务采购、平台会员与投币、应援物料，以及少量机动费用。公开账目做得好的组织会逐笔列出，但更多时候，粉丝只能看到总金额和一个模糊的用途说明。",
          "一位前管理员坦言，最难处理的不是花钱，而是「向粉丝证明这笔钱确实花在了投票上」。当票数无法被独立验证时，账目就成了唯一可以追问的线索。",
        ],
      },
      {
        heading: "这笔账谁在算",
        paragraphs: [
          "值得注意的是，成本的最终承担者往往不是主办方，也不是平台，而是粉丝自己。名次竞争越激烈，投入的边际收益越低，最后变成一场谁都停不下来的消耗。",
          "当我们讨论「一票值多少钱」时，真正该问的或许是：这一票，究竟值不值得。",
        ],
      },
    ],
  },
  {
    id: "three-scoring-rules",
    title: "评委加权还是人气为王：三套计票规则拆解",
    excerpt:
      "同样是选美比赛，有的把网络票数计入三成，有的只看人气排名。规则怎么设计，直接决定榜单吵不吵。",
    category: "赛事规则",
    date: "2026-08-18",
    readTime: "6 分钟",
    author: "陈砚",
    cover:
      "https://readdy.ai/api/search-image?query=Minimalist%20dark%20stage%20with%20three%20illuminated%20glass%20panels%20floating%20above%20a%20polished%20floor%2C%20warm%20gold%20edge%20lighting%2C%20stylized%20editorial%20photography%2C%20clean%20geometric%20composition%2C%20premium%20magazine%20aesthetic%2C%20no%20people&width=1200&height=800&seq=guaguan-scoring-rules&orientation=landscape",
    coverAlt: "舞台上悬浮的三块发光规则面板",
    tags: ["计票规则", "赛制", "人气排名"],
    featured: false,
    sections: [
      {
        heading: "第一种：评委主导、票数微调",
        paragraphs: [
          "这类赛制里，专业评委打分占七成以上，网络投票只作为「人气加分」影响小幅排序。它的好处是结果相对稳定，也不容易被短时间的票数暴冲左右。",
          "但代价是参与感弱。粉丝会发现无论怎么拉票，名次几乎不动，久而久之投票就成了一种形式。",
        ],
      },
      {
        heading: "第二种：评委与票数各半",
        paragraphs: [
          "这是最容易吵架的一档。当票数权重接近五成时，网络打榜的投入产出比变得极其敏感，任何一次票数波动都会被放大成「是不是注水」的讨论。",
          "我们看过的几场争议赛事，几乎都出现在这种权重结构下。它不是坏规则，但它对数据透明度的要求最高。",
        ],
      },
      {
        heading: "第三种：纯人气排名",
        paragraphs: [
          "完全交由网络投票决定的赛制，名次几乎等于资源投入的排名。这类比赛观感最刺激，也最容易催生组织化打榜和账号买卖。",
          "规则本身没有对错，关键是配套的校验机制跟不跟得上。如果无法识别异常投票，纯人气赛制几乎必然走向军备竞赛。",
        ],
      },
    ],
  },
  {
    id: "five-inflation-tricks",
    title: "票数注水的五种常见手法，以及它们留下的痕迹",
    excerpt:
      "注水不是凭空变出票数，它总要在数据里留下痕迹。我们总结了五种高频手法和对应的可疑信号。",
    category: "票数分析",
    date: "2026-08-15",
    readTime: "9 分钟",
    author: "瓜圈显微镜编辑部",
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20dark%20red%20liquid%20droplets%20suspended%20in%20mid%20air%20against%20a%20deep%20charcoal%20backdrop%20with%20gold%20rim%20lighting%2C%20stylized%20macro%20editorial%20photography%2C%20dramatic%20and%20premium%20magazine%20aesthetic%2C%20no%20people&width=1200&height=800&seq=guaguan-five-tricks&orientation=landscape",
    coverAlt: "深色背景下悬浮的暗红色液滴抽象画面",
    tags: ["票数注水", "异常检测", "数据打假"],
    featured: true,
    sections: [
      {
        heading: "一、批量新号集中投放",
        paragraphs: [
          "最直接的方式是在短时间内注册大量新账号并集中投票。痕迹也很明显：新增投票账号的注册时间高度聚集，且普遍缺少头像、简介和历史互动。",
        ],
      },
      {
        heading: "二、设备指纹重复",
        paragraphs: [
          "一些操作者会复用一个浏览器环境轮换账号登录。这种情况下，虽然账号不同，但设备指纹高度重合，提交时间间隔也呈现机械的规律性。",
        ],
      },
      {
        heading: "三、限速边缘的稳定输出",
        paragraphs: [
          "为规避风控，有的投放会刻意把速度控制在平台阈值之下，形成一条「过分平滑」的增长曲线。真实粉丝投票会因为作息和情绪出现明显起伏，过于均匀反而可疑。",
        ],
      },
      {
        heading: "四、跨平台联动刷量",
        paragraphs: [
          "当比赛同时开放多个平台投票时，异常往往出现在所有平台同步暴涨的时段。单一平台的小幅波动可能是运营动作，多平台同频跳涨则更值得深挖。",
        ],
      },
      {
        heading: "五、压票与回填",
        paragraphs: [
          "还有一种更隐蔽的做法：先大量提交但延迟释放，在关键时间点「回填」成票数。这种方式会让数据在某个时刻突然补齐，看起来像系统故障，实际上时机被精心选择过。",
        ],
      },
    ],
  },
  {
    id: "spot-bot-votes",
    title: "数据打假入门：普通人也能看懂的三个可疑信号",
    excerpt:
      "你不需要会写代码，也能从公开的榜单页面里读出异常。这里是最容易上手的三个观察角度。",
    category: "打榜观察",
    date: "2026-08-12",
    readTime: "6 分钟",
    author: "苏黎",
    cover:
      "https://readdy.ai/api/search-image?query=Magnifying%20glass%20resting%20on%20a%20printed%20ranking%20spreadsheet%20under%20warm%20gold%20desk%20light%2C%20dark%20crimson%20desk%20surface%2C%20stylized%20editorial%20photography%2C%20shallow%20depth%20of%20field%2C%20premium%20magazine%20aesthetic%2C%20no%20people&width=1200&height=800&seq=guaguan-spot-bots&orientation=landscape",
    coverAlt: "放大镜放在印有排名数据的表格上",
    tags: ["数据打假", "异常信号", "入门"],
    featured: false,
    sections: [
      {
        heading: "看增速，不看总量",
        paragraphs: [
          "总票数高不等于异常，增长速度快才值得注意。把同一时段各选手的增量放在一起比较，如果出现量级上的断层，就值得往下追问。",
        ],
      },
      {
        heading: "看新增账号的「新」",
        paragraphs: [
          "很多平台会展示投票账号的公开信息。注册时间集中在同一天、名字由随机字符组成、没有关注任何人的账号，成批出现时基本可以判定为非自然增长。",
        ],
      },
      {
        heading: "看时间点是否撞上「非活跃时段」",
        paragraphs: [
          "真实粉丝的活跃时间通常集中在晚间和周末。凌晨的突然放量、工作日下午的整点跳涨，都是需要解释的时点。有解释不等于有问题，但没有解释就值得记一笔。",
        ],
      },
    ],
  },
  {
    id: "girls-beside-the-list",
    title: "榜单之外的她们：陪跑选手的真实处境",
    excerpt:
      "热搜只记得前三名。剩下的选手在投票结束后，面对着完全不同的现实——有人继续演出，有人转行，也有人彻底离开了这个圈子。",
    category: "幕后故事",
    date: "2026-08-09",
    readTime: "8 分钟",
    author: "林知夏",
    cover:
      "https://readdy.ai/api/search-image?query=Empty%20theatre%20stage%20seen%20from%20the%20back%20of%20the%20hall%2C%20single%20warm%20spotlight%20illuminating%20the%20floor%2C%20deep%20crimson%20curtains%2C%20stylized%20editorial%20photography%2C%20melancholic%20and%20cinematic%2C%20premium%20magazine%20aesthetic%2C%20no%20people&width=1200&height=800&seq=guaguan-beside-list&orientation=landscape",
    coverAlt: "从观众席后方看到的空舞台与一束追光",
    tags: ["幕后故事", "选手", "选美生态"],
    featured: false,
    sections: [
      {
        heading: "聚光灯之外的时间更长",
        paragraphs: [
          "一位止步二十强的选手说，比赛那两周是她人生里被看见最多的时间，之后半年，她的社交账号几乎没有新的合作邀约。名次带来的曝光窗口，比她预想的短得多。",
        ],
      },
      {
        heading: "被数据定义的努力",
        paragraphs: [
          "不少陪跑选手都提到同一个感受：她们在台上的表现，最终被简化成一个票数排名。训练、台风、临场发挥，这些不容易量化的东西，在打榜语境里都被一句「票不够」盖过去了。",
        ],
      },
      {
        heading: "离开之后",
        paragraphs: [
          "有人转型做形体与礼仪培训，有人回到原本的工作岗位，也有人坦言再也不想参加任何需要投票的比赛。她们的故事很少上热搜，但构成了这个行业更真实的那一面。",
        ],
      },
    ],
  },
  {
    id: "fundraising-ledger",
    title: "应援集资账本疑云：打榜的钱最后都去哪了",
    excerpt:
      "一次集资超过六位数，公示的支出却只有几行概要。粉丝要求看明细，得到的回复是「不方便公开」。",
    category: "粉丝生态",
    date: "2026-08-05",
    readTime: "7 分钟",
    author: "莫见微",
    cover:
      "https://readdy.ai/api/search-image?query=An%20open%20leather%20bound%20ledger%20with%20blank%20pages%20and%20a%20gold%20fountain%20pen%20on%20a%20dark%20wooden%20desk%2C%20warm%20low%20key%20lighting%2C%20stylized%20editorial%20photography%2C%20mysterious%20premium%20magazine%20aesthetic%2C%20no%20people&width=1200&height=800&seq=guaguan-ledger&orientation=landscape",
    coverAlt: "深色木桌上的皮革账本与金色钢笔",
    tags: ["集资", "账目", "后援会"],
    featured: false,
    sections: [
      {
        heading: "公示与明细之间的距离",
        paragraphs: [
          "集资结束后，后援会照例发布了一张支出概览图：投票服务、物料制作、平台费用、机动支出，四个条目占满了整张图。但当粉丝在评论区追问具体金额与凭证时，讨论很快被设置为仅粉丝可见。",
        ],
      },
      {
        heading: "信任是怎么被消耗的",
        paragraphs: [
          "组织者通常有自己的难处：对接的供应商不愿暴露身份，单据涉及隐私，反复解释成本很高。但对出资的粉丝来说，看不到凭证就等于没有凭证，一次含糊足以抵消十次勤勉。",
        ],
      },
      {
        heading: "一条可行的做法",
        paragraphs: [
          "也有后援会做得相当规范：把每一笔支出拆到最小单位，附上带有时间戳的截图，关键节点开直播答疑。这样的组织未必规模最大，但集资的效率与留存明显更好。",
          "透明不是对热情的消耗，恰恰相反，它是让热情可以持续下去的前提。",
        ],
      },
    ],
  },
  {
    id: "rule-changes-2026",
    title: "规则年年在改，人气榜为什么越改越吵",
    excerpt:
      "从取消实时票数到引入评委加权，主办方每年都在调整规则。但围绕榜单的争议，似乎从来没有真正减少过。",
    category: "赛事规则",
    date: "2026-07-30",
    readTime: "6 分钟",
    author: "陈砚",
    cover:
      "https://readdy.ai/api/search-image?query=Stack%20of%20updated%20rule%20documents%20and%20a%20gold%20seal%20stamp%20under%20warm%20directional%20light%2C%20deep%20crimson%20folder%2C%20stylized%20editorial%20photography%2C%20minimal%20composition%2C%20premium%20magazine%20aesthetic%2C%20no%20people&width=1200&height=800&seq=guaguan-rule-change&orientation=landscape",
    coverAlt: "暖光下的一叠规则文件与金色印章",
    tags: ["赛事规则", "赛制调整", "争议"],
    featured: false,
    sections: [
      {
        heading: "改动往往出现在争议之后",
        paragraphs: [
          "翻看近几年的赛制调整说明，会发现一个稳定的规律：规则修改几乎都发生在一次大规模争议之后。取消实时票数、增加评委权重、限制单账号投票次数，这些措施都指向同一个目标——让结果看起来更合理。",
        ],
      },
      {
        heading: "改规则不等于解决问题",
        paragraphs: [
          "问题在于，规则越复杂，理解门槛越高，普通观众越难判断结果是否公正。当投票逻辑变成一个黑箱，争议不是被消解，而是被延后。",
        ],
      },
      {
        heading: "真正需要改的是什么",
        paragraphs: [
          "与其反复调整权重，不如先把数据公开做扎实：票数曲线、账号结构、复核流程。规则可以复杂，但校验必须透明。观众能看懂数据，才有机会相信排名。",
        ],
      },
    ],
  },
];